import { Locale } from "../type";

export let locale: Locale = Locale.zh_CN;

/**
 * 设置SDK国际化语言
 *
 * @param { Locale } language 语言
 */
export const setLocale = (language: Locale) => {
  const { zh_CN, en_US, zh_TW } = Locale;

  locale = [zh_CN, en_US, zh_TW].includes(language) ? language : Locale.zh_CN;
};
